export const SET_SELECTED_NODE = "SET_SELECTED_NODE";
export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_SELECTED_INTERACTOR = "SET_SELECTED_INTERACTOR";
export const SET_SELECTED_NEXT_STAGE = "SET_SELECTED_NEXT_STAGE";
export const SET_HISTORY = "SET_HISTORY";
export const SET_DISPLAY_NODE = "SET_DISPLAY_NODE";
